import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import EditorChoice from "./components/EditorChoice";
import LatestQuestSection from "./components/LatestQuestSection";
import ServiceIntro from "./components/ServiceIntro";
import Footer from "./components/Footer";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#0a0a0f]">
      <Navbar />
      <HeroSection />
      <EditorChoice />
      <LatestQuestSection />
      <ServiceIntro />
      <Footer />
    </div>
  );
}
